import React, { useEffect, useState } from 'react';
import { Checkbox } from 'Components/Form';
import Modal from 'Components/Modal';
import Otp from 'Components/Modal/Otp';
import Message from 'Components/Modal/Message';

import { openModal, closeModal, loginWithOtpModal, resetOtpError, sendOtpTrustedDevice } from 'Store/actions';

import EnvironmentManager from 'Utils/environmentManager';
import { useDispatch, useSelector } from 'react-redux';
import { withMixpanel } from 'Utils/mixpanel';


const TrustedDeviceModal = ({ mixpanel }) => {
  const [otpType, setOtpType] = useState(null);
  const dispatch = useDispatch();
  const { trustedDeviceError, otpError, otpInfo, sendOtpError } = useSelector(state => state.auth);
  const modalData = useSelector(state => state.modalData);

  const modalContentTitle = EnvironmentManager.getMessageText({ key: 'title_forgot_password_choose_otp_channel' }) || 'Aşağıdaki yöntemlerden birini seçerek devam edebilirsin.';
  const checkBoxTel = EnvironmentManager.getMessageText({ key: 'description_forgot_password_choose_otp_sms' }) ||  '<b>%@</b> numaralı telefonuma doğrulama kodu gönder';
  const checkBoxMail = EnvironmentManager.getMessageText({ key: 'description_trusted_device_choose_otp_email' }) ||  '<b>%@</b> e-posta adresime doğrulama kodu gönder';
  const trustedDeviceSuccesMessage = EnvironmentManager.getMessageText({ key: 'trusted_device_description_completed' }) ||  'Güvenli giriş sağlandı. Kaldığınız yerden devam edin.';
  const trustedDeviceCompletedTitle = EnvironmentManager.getMessageText({ key: 'trusted_device_title_completed' }) ||  'Harika! Doğrulama Tamamlandı';
  const trustedDeviceLastStepTitle = EnvironmentManager.getMessageText({ key: 'one_last_step' }) ||  'Son Bir Adım Kaldı!';
  const trustedDeviceTitle = EnvironmentManager.getMessageText({ key: 'trusted_device_modal_title' }) || 'Giriş Yapmak İçin Devam Et';

  const getPasswordModalContent = ()=> {
    const isCallFromMHisOpen = EnvironmentManager.getMessageText({ key: 'callcentercallme_mw_switch' }) === 'true';
  
    const tel = EnvironmentManager.getMessageText({ key: 'callcentercallme_display_number' }) || '0850 272 0 272';
    const telLink = EnvironmentManager.getMessageText({ key: 'callcentercallme_call_number' }) || '+908502720272';
    const defaultText = (EnvironmentManager.getMessageText({ key: 'descripton_callcentercallme_warning_message' }) || 'Eğer yukarıdaki bilgiler güncel değilse');
    const defaultText_2 = (EnvironmentManager.getMessageText({ key: 'descripton_callcentercallme_warning_message_2' }) || 'numarasından arayarak bilgilerini güncelleyebilirsin.');
  
    if (!isCallFromMHisOpen) {
      return <span>{ defaultText }
        <a
          href={ `tel:${telLink}` }
          onClick={ () => {} }>
          { ` Müşteri Hizmetlerimizi (${ tel }) ` }
        </a>
        { defaultText_2 }</span>;
    }
  
    const featureLink = <b className='link' onClick={ ()=>{
      this.props.closeModal('chooseChangePasswordFlow');
    } }>buradan</b>;
  
    const featureText =  EnvironmentManager.getMessageText({ key: 'description_callcentercallme_message' }) || 'Eğer yukarıdaki bilgiler güncel değilse seni aramamız için güncel telefon numaranı';
    const featureText1 = EnvironmentManager.getMessageText({ key: 'description_callcentercallme_message_2' }) || 'iletebilirsin.';
    const featureText2 = (EnvironmentManager.getMessageText({ key: 'description_callcentercallme_message_3' }) ||  'numarasından Müşteri Hizmetlerini arayabilirsin.');
  
    return (
      <>
        { featureText } { featureLink } { featureText1 }
        <div className='bottom-note'>
          <a href={ `tel:${telLink}` } onClick={ ()=>{
          } } >({ tel }) </a>
          { featureText2 }
        </div>
      </>
    );
  };

  const isModalOpen = modalNameRequest => {
    const { modalNames } = modalData;
    return modalNames.some(modalName => modalName === modalNameRequest);
  };

  useEffect(() => {
    if (isModalOpen('succesLoginWithOtp')) {
       mixpanel?.track('OTP Result', { source: 'Login', status: 'success', trusted_device: 'yes' });
       mixpanel?.track('Complete SMS Verification', { Source: 'Trusted Device' });
    }
  }, [isModalOpen('succesLoginWithOtp')]);

  useEffect(() => {
    const isSmsModalOpen = isModalOpen('loginWithSmsOtpModal');
    const isEmailModalOpen = isModalOpen('loginWithEmailOtpModal');

    if ((isSmsModalOpen || isEmailModalOpen) && Object.keys(otpInfo).length > 0) {
      mixpanel?.track('OTP Form', { source: 'Login' });
    }
  }, [otpInfo, modalData]);

  useEffect(() => {
    if (otpError) {
      mixpanel?.track('OTP Result', { source: 'Login', status: 'fail', error_message: otpError, trusted_device: 'no' });
    }
  }, [otpError]);

  const getSelection = () => {
    if (otpType === 'SMS') {
      return 'phone';
    }
    if (otpType === 'EMAIL') {
      return 'email';
    }
  };

  const onSubmitOtp = codeValue => {
    const {  externalCustomerId = '', } = trustedDeviceError || {};
    const getLoginForm = true;
    if (codeValue) {
      const loginDataWithOtp = {
        externalCustomerId,
        otpType,
        otp: {
          referenceId: otpInfo?.referenceId,
          code: codeValue
        }
      };
      dispatch(loginWithOtpModal(loginDataWithOtp, getLoginForm));
    }
  };

  const sendOtpCode =  async (externalCustomerId, otpType) => {
    const otpData = {
      externalCustomerId,
      otpType
    };
    await dispatch(sendOtpTrustedDevice(otpData));
     
    dispatch(closeModal('trustedDeviceModal'));
    setTimeout(() => {
      if (otpType === 'SMS') {
        dispatch(openModal('loginWithSmsOtpModal'));
      } else if (otpType === 'EMAIL') {
        dispatch(openModal('loginWithEmailOtpModal'));
      }
    }, 0);
  };


  const showContent = () => {
    const { email = '', isTrusted = true, phoneNumber = '', externalCustomerId = '' } = trustedDeviceError || {};

    if (isModalOpen('loginWithSmsOtpModal') && Object.keys(otpInfo).length > 0) {
      return (
        <Modal
          headerColor='green'
          title={ trustedDeviceLastStepTitle }
          onClose={ () => {
            dispatch(closeModal('loginWithSmsOtpModal'));
            dispatch(closeModal([]));
          } }
        >
          <Otp
            title={ trustedDeviceLastStepTitle }
            errorText={ otpError }
            phone={ phoneNumber }
            expireTimeInSeconds={ otpInfo?.expireTimeInSeconds }
            onSubmit={ code => onSubmitOtp(code) }
            sendOtpCode = { () => {
              mixpanel?.track('Resend Button', { source: 'Login' });
              sendOtpCode(externalCustomerId, otpType);
              dispatch(resetOtpError());
            } }
          />
        </Modal>
      );
    }
    if (isModalOpen('loginWithEmailOtpModal') && Object.keys(otpInfo).length > 0) {
      return (
        <Modal
          headerColor='green'
          title={ trustedDeviceLastStepTitle }
          onClose={ () => {
            dispatch(closeModal('loginWithEmailOtpModal'));
            dispatch(closeModal([]));
          } }
        >
          <Otp
            errorText={ otpError }
            email={ email }
            expireTimeInSeconds={ otpInfo?.expireTimeInSeconds }
            onSubmit={ code => onSubmitOtp(code) }
            sendOtpCode = { () => {
               mixpanel?.track('Resend Button', { source: 'Login' });
               sendOtpCode(externalCustomerId, otpType);
               dispatch(resetOtpError());
            } }
          />
        </Modal>
      );
    }
    if (isModalOpen('succesLoginWithOtp')) {
      return (
        <Modal
          headerColor='green'
          title={ trustedDeviceCompletedTitle }
          type="success"
          onClose={ () => {
            dispatch(closeModal('succesLoginWithOtp'));
            dispatch(closeModal([]));
          } }
          buttonArea={ {
            primaryButton: {
              disabled: false,
              label: 'Tamam',
              onClick: () => {
                dispatch(closeModal('succesLoginWithOtp'));
                dispatch(closeModal([]));
              }
            }
          } }
        >
          <Message type="none">
            { trustedDeviceSuccesMessage }
          </Message>
        </Modal>
      );
    }
    if (isModalOpen('errorTrustedDeviceModal')) {
      return (
        <Modal
          title="İşlem gerçekleşmedi"
          type="error"
          iconName="svgInfoRed"
          onClose={ () => {
            dispatch(closeModal('errorTrustedDeviceModal'));
            dispatch(closeModal('trustedDeviceModal'));
          } }
          buttonArea={ {
            primaryButton: {
              disabled: false,
              label: 'Tamam',
              onClick: () => {
                dispatch(closeModal('errorTrustedDeviceModal'));
                dispatch(closeModal('trustedDeviceModal'));
              }
            }
          } }
        >
          <Message type="none">
            { sendOtpError }
          </Message>
        </Modal>
      );
    }
    if (!isTrusted && isModalOpen('trustedDeviceModal')) {
      return (
        <Modal
          headerColor='green'
          title={ trustedDeviceTitle }
          onClose={ () =>  {
            dispatch(closeModal('trustedDeviceModal'));
            dispatch(closeModal([]));
          } }
          buttonArea={ {
            primaryButton: {
              disabled: otpType === null,
              label: EnvironmentManager.getMessageText({ key: 'button_forgot_password_choose_otp_channel' }) || 'Gönder',
              onClick: () => {
                mixpanel?.track('OTP Method Selection', {
                  selection: getSelection(otpType),
                  source: 'Login'
                });
                sendOtpCode(externalCustomerId, otpType);
              }

            }
          } }
        >
          <div className='modal__content'>
            <Message type="none">
              <div className="forgot-password-options">
                <div className='forgot-password-options-title'>
                  { modalContentTitle }
                </div>
                { phoneNumber &&  <Checkbox
                  checked={ otpType === 'SMS' }
                  onChange={ () => setOtpType('SMS') }
                >
                  <span dangerouslySetInnerHTML={ { __html: checkBoxTel.replace('%@', `${phoneNumber}` ) } } />
                </Checkbox>  }
        
                { email &&  <Checkbox
                  checked={ otpType === 'EMAIL' }
                  onChange={ () => setOtpType('EMAIL') }
                >
                  <span dangerouslySetInnerHTML={ { __html: checkBoxMail.replace('%@', `${email}` ) } } />
                </Checkbox> }
              </div>
            </Message>
            <div className="forgot-password-options-text">
              { getPasswordModalContent() }
            </div>
          </div>
        </Modal>
      );
    }
    
    return null;
  };

  return showContent();
};

export default withMixpanel(TrustedDeviceModal);
